var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    d: "m8.914 4.132-.703.668c-.14.176-.14.457 0 .597l6.363 6.399-6.363 6.363c-.14.14-.14.422 0 .598l.703.668a.405.405 0 0 0 .598 0l7.383-7.348a.476.476 0 0 0 0-.598L9.512 4.132a.405.405 0 0 0-.598 0"
  })));
};
export default SvgChevronRight;